import { render, staticRenderFns } from "./servicesProduct3.vue?vue&type=template&id=4383965e&scoped=true"
import script from "./servicesProduct3.vue?vue&type=script&lang=js"
export * from "./servicesProduct3.vue?vue&type=script&lang=js"
import style0 from "./servicesProduct3.vue?vue&type=style&index=0&id=4383965e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4383965e",
  null
  
)

export default component.exports